import NiceModal from '@ebay/nice-modal-react';

import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import useLocalStorage from 'hooks/useLocalStorage';
import useMediaQuery from 'hooks/useMediaQuery';

import LayoutPreferenceModal from 'pages/Settings/Profile/LayoutPreferenceModal';

import { Breakpoints } from 'utils/const.styles';

import ConfirmationModal from './ConfirmationModal';

const HorizontalScreenChecker = ({ children }) => {
	const [isShownBefore, setIsShownBefore] = useLocalStorage('horizontalScreenAlert', false);
	const isIframe = window.self !== window.top;
	const isLandScape = useMediaQuery('(orientation: landscape)');
	const isTablet = useMediaQuery(Breakpoints.tablet);
	const { mobile } = useSelector((state) => state.layout);

	useEffect(() => {
		if (mobile && isTablet && isLandScape && !isShownBefore && !isIframe) {
			setIsShownBefore(true);

			NiceModal.show(ConfirmationModal, {
				title: 'rotationAlertTitle',
				subTitle: 'rotationAlertSubTitle',
				lottieName: 'rotate-phone',
				yesAction: () => NiceModal.show(LayoutPreferenceModal),
				rejectLabel: 'okay',
				confirmLabel: 'changeFontSize',
				lottieStyle: { width: 120, height: 120, backgroundColor: '#e2dbe7', borderRadius: '100%' }
			});
		}
	}, [isLandScape, isShownBefore, isIframe, isTablet, mobile]);

	return children;
};

export default HorizontalScreenChecker;
